import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getConfigurableProducts } from "../../api";
import { setActiveThreekitParams, setAllSettingConfig } from "../../store/actions/setting";
import load3kit from "../../store/utils/load3kit";
//@ts-ignore
import s from "./PlayerThreeKit.module.scss";
declare global {
  interface Window {
    threekitPlayer: any;
    player: any;
    configurator: any;
  }
}

export const THREEKIT_PARAMS = {
  threekitUrl: "https://preview.threekit.com/",
  authToken: "44734acb-1194-444c-8bdc-703bb966cd9b",
  assetId: "fd40ff7f-f91b-438f-87c5-b8f23735d047",
  elementId: "fd40ff7f-f91b-438f-87c5-b8f23735d047",
  orgId: "49ccde0b-afe6-4828-9f34-81ea84f083ed",
}



export const PlayerThreeKit = () => {
  // const dispatch = useDispatch();
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);
  const playerEl: any = React.createRef();

  const init3kit = () => {
    if (!playerEl.current) return false;

    if (window.threekitPlayer) {



      window
        .threekitPlayer({
          authToken: THREEKIT_PARAMS['authToken'],
          el: playerEl.current,
          assetId: THREEKIT_PARAMS['assetId'],
          // initialConfiguration: startThreeKit,
          // showConfigurator: "true",

        })
        .then(async (api: any) => {
          window.player = api;
          await window.player.when('loaded');
          // api.tools.addTool('zoom')
          // await dispatch(loadConfig());
          window.configurator = await api.getConfigurator();


          dispatch(setActiveThreekitParams({ configurationParams: window.configurator.getConfiguration() }))



        });
    }
  };

  useEffect(() => {
    load3kit(null, () => {
      setLoaded(true);
      init3kit();
    });
  });

  return (
    <div className={s.player_wrapper}>
      {loaded ? <div id="player" className={s.player} ref={playerEl} /> : ""}
    </div>
  );
}
// export const PlayerThreeKit = () => {
//   const dispatch = useDispatch();

//   const [loaded, setLoaded] = useState(false);
//   const playerEl: any = React.createRef();

//   // const init3kit = () => {
//   //   if (!playerEl.current) return false;

//   //   if (window.threekitPlayer) {
//   //     window
//   //       .threekitPlayer({
//   //         authToken: "d56cf180-8322-4ab9-9907-a1588cbc540b",
//   //         el: playerEl.current,
//   //         assetId: "2afa5b5f-48fe-4f28-8e0f-a1b8acb0aac0",
//   //         initialConfiguration: startThreeKitObject,
//   //         // showConfigurator: "true",
//   //         display: "image",
//   //       })
//   //       .then(async (api: any) => {
//   //         window.player = api;
//   //         api.tools.addTool('zoom')
//   //         dispatch(loadConfig());
//   //         window.configurator = await api.getConfigurator();
//   //       });
//   //   }
//   // };

//   // let query = URLSearchParams(useLocation().search);

//   useEffect(() => {



//   }, [playerEl]);

//   launch({ ...THREEKIT_PARAMS, playerEl, callback: () => setLoaded(true) })
//   .then((res) => {




//     dispatch(loadConfig());
//   })

//   return (
//     <div className={s.player_wrapper}>
//       {loaded ? <div id="player" className={s.player} ref={playerEl} /> : ""}
//     </div>
//   );
// };



